<template>
<megaMenu v-if="!isInline" :options="{isBlock: this.isBlock,  minWidth: '100%'}" @open="onShow" @close="onHide" ref="datePicker">
  <template v-if="isDesktop || forceDesktop" >
    <div class="flex justify-between items-center text-grey p-8 lg:px-16 rounded select-none cursor-pointer" tabindex="-1" @click="dateInputClick">
      <div class="text-grey-darkest leading-md">
        <div class="flex">
          <div class="text-xs font-bold mr-4 text-grey-dark">{{ $t('checkIn.text') }}</div>
          <div v-if="value.start" class="text-sm font-bold">{{ value.start | toDate('YYYY') }}</div>
        </div>
        <div>
          <div v-if="!value.start" class="font-bold">{{ $t('checkIn.date') }}</div>
          <div v-else class="font-bold">{{ value.start | toDate('MM / DD ddd') }}</div>
        </div>
      </div>
      <div> - </div>
      <div class="text-grey-darkest leading-md">
        <div class="flex">
          <div class="text-xs font-bold mr-4 text-grey-dark">{{ $t('checkOut.text') }}</div>
          <div v-if="value.end" class="text-sm font-bold">{{ value.end | toDate('YYYY') }}</div>
        </div>
        <div>
          <div v-if="!value.end" class="font-bold">{{ $t('checkOut.date') }}</div>
          <div v-else class="font-bold">{{ value.end | toDate('MM / DD ddd') }}</div>
        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <span class="mr-8">
      <span v-if="value.start && value.end">
        {{ value.start | toDate('MM / DD ddd') }} ~ {{ value.end | toDate('MM / DD ddd') }}
      </span>
      <span v-else>{{ $t('checkIn.date') }} ~ {{ $t('checkOut.date') }}</span>
    </span>
  </template>
  <template v-slot:dropdown>
    <v-date-picker
      :key="datePickerKey"
      :attributes="attrs"
      :locale="$store.getters.datePickerLocale"
      mode="range"
      v-model.lazy="value"
      @input="onInput"
      @drag="onDrag"
      :available-dates="avaiableDates"
      :disabled-dates="disabledDates"
      color="blue"
      :min-date="minDate"
      :max-date="maxDate"
      :columns="$screens({ default: 1, md: 2, lg: 2 })"
      :popover="{
        visibility: 'focus'
      }"
      is-range
      is-inline
      is-expanded
      style="border: 0;"
      class="owj-calendar"
      :class="inHotelDetail ? 'inHotelDetail' : ''"
      @update:from-page="monthChange"
    >
      <template v-slot:day-content="{ day, dayEvents }" v-if="inHotelDetail">
        <div v-on="dayEvents"
          tabindex="-1"
          class="w-full cursor-pointer vc-day-content"
          :class="[day.isDisabled && 'cursor-not-allowed text-grey']"
        >
          {{day.label}}
        </div>
        <div style="font-size: 10px;" :class="day.isDisabled ? 'text-grey' : 'text-grey-darker'" v-html="checkDayPrice(day)" />
      </template>
    </v-date-picker>
  </template>
</megaMenu>
<div v-else>
  <v-date-picker
    class="ease border-0 mt-16 owj-calendar"
    :key="datePickerKey"
    :attributes="attrs"
    :class="{'border border- border-blue-light': isMobileFocus, 'inHotelDetail': inHotelDetail}"
    :locale="$store.getters.datePickerLocale"
    mode="range"
    v-model.lazy="value"
    @input="onInput"
    @drag="onDrag"
    :available-dates="avaiableDates"
    :disabled-dates="disabledDates"
    color="blue"
    :min-date="minDate"
    :max-date="maxDate"
    :columns="$screens({ default: 1, md: 2, lg: 2 })"
    :popover="{
      visibility: 'focus'
    }"
    is-range
    is-inline
    is-expanded
    style="width: 100%"
    @update:from-page="monthChange"
  >
    <template v-slot:day-content="{ day, dayEvents }" v-if="inHotelDetail">
      <div v-on="dayEvents"
        tabindex="-1"
        class="w-full cursor-pointer vc-day-content"
        :class="[day.isDisabled && 'cursor-not-allowed text-grey']"
      >
        {{day.label}}
      </div>
      <div v-if="inHotelDetail" style="font-size: 10px;" :class="day.isDisabled ? 'text-grey' : 'text-grey-darker'" v-html="checkDayPrice(day)" />
    </template>
  </v-date-picker>
  <div v-if="inHotelDetail" class="text-xs font-bold text-grey-darkest px-8 mb-8 text-center break-words whitespace-normal">
    {{ $t('currencyRemain', { currency: selectedCurrency })}}
  </div>
  <div v-show="nightCount > 0" class="font-bold text-blue-light text-center">{{ $t('nightCount', { count: nightCount }) }}</div>
  <div v-if="isMobileFocus" class="text-blue text-center font-bold mt-4">{{ $t('selectDate') }}</div>
</div>
</template>

<script>
// import Modal from './index.js'
import { mapGetters, mapMutations } from 'vuex'
import SimpleVueValidation from 'simple-vue-validator'

import quarantineHotelMixin from '@/mixins/quarantineHotel'

const Validator = SimpleVueValidation.Validator

export default {
  name: '',
  props: {
    forceDesktop: {
      type: Boolean
    },
    isInline: {
      type: Boolean
    },
    isBlock: {
      type: Boolean
    }
  },
  mixins: [
    quarantineHotelMixin
  ],
  validators: {
    'start': function (val) {
      if (typeof val === 'undefined') {
        val = null
      }
      return Validator.value(val).required()
    },
    'end': function (val) {
      if (typeof val === 'undefined') {
        val = null
      }
      return Validator.value(val).required()
    }
  },
  data () {
    return {
      start: null,
      end: null,
      datePickerKey: 0,
      isMobileFocus: false,
      nightCount: 0,
      isDraging: false,
      disabledAttribute: {
        contentStyle: {
          backgroundColor: '#F8FAFC',
          color: '#D1D7DD'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
      isQuarantineHotel: 'hotels/isQuarantineHotel',
      quarantineDatepickerStyle: 'hotels/quarantineDatepickerStyle', // 春節防疫旅館特殊需求
      inventory: 'hotels/inventory',
      inventoryPrice: 'hotels/inventoryPrice',
      isLoadingInventory: 'hotels/isLoadingInventory',
      selectedCurrency: 'user/selectedCurrency',
      hotel: 'hotels/hotel'
    }),
    inHotelDetail: function () {
      return this.$route.name === 'HotelDetail'
    },
    setQuarantineDatepickerStyle: function () {
      return this.isQuarantineHotel && this.$route.name === 'HotelDetail'
    },
    value: {
      get: function () {
        return {
          start: this.start,
          end: this.end
        }
      },
      set: function (newValue) {
        [this.start, this.end] = [newValue.start, newValue.end]
      }
    },
    attrs: function () {
      return [{
        highlight: {
          start: { fillMode: 'solid', contentClass: 'text-blue-light' },
          base: { fillMode: 'light', contentClass: 'text-blue-light' },
          end: { fillMode: 'solid', contentClass: 'text-blue-light' }
        },
        ...(this.value.start && this.value.end && this.isDraging === false ? { dates: {
          start: this.value.start,
          end: this.value.end
        } } : {})
      }]
    },
    avaiableDates: function () {
      if (this.isDraging) {
        const disabledDates = this.inventory ? this.inventory : []
        const startDate = new Date(this.isDraging.start)
        let closestDisabledDate = Infinity
        disabledDates.forEach(date => {
          const disabledDate = new Date(date)
          if (disabledDate >= startDate && (disabledDate < new Date(closestDisabledDate) || disabledDate < closestDisabledDate)) {
            closestDisabledDate = date
          }
        })
        if (closestDisabledDate !== Infinity) {
          return {
            start: this.$dayjs(this.isDraging.start).format('YYYY-MM-DD'),
            end: this.$dayjs(closestDisabledDate).format('YYYY-MM-DD')
          }
        }
        return null
      }
      return null
    },
    disabledDates: function () {
      if (this.isLoadingInventory) {
        return {
          start: this.$dayjs().subtract(1, 'year').format('YYYY-MM-DD'),
          end: this.$dayjs().add(1, 'year').format('YYYY-MM-DD')
        }
      }
      if (this.isDraging) {
        return null
      }
      return this.inventory
    },
    minDate: function () {
      if (this.isDraging && this.inventory) {
        return null
      }
      return this.$dayjs().toDate()
    },
    maxDate: function () {
      if (this.isDraging && this.inventory) {
        return null
      }
      return this.$dayjs().add(1, 'year').toDate()
    }
  },
  methods: {
    ...mapMutations([
      'hotels/SET_QUARANTINE_DATEPICKER_STYLE'
    ]),
    createTextElement: function () {
      /** 為了在 v-date-picker 中加入自定義文字，建立 night_count 元素 */
      const calendarTargets = document.getElementsByClassName('vc-pane-container')
      const textTarget = document.getElementById('night_count')
      if (!textTarget && calendarTargets.length) {
        const newElement = document.createElement('div')
        newElement.setAttribute('id', 'night_count')
        newElement.classList.add('font-bold', 'px-16', 'pb-8', 'text-center', 'text-blue-light')

        if (this.inHotelDetail) {
          const priceRemindElement = document.createElement('div')
          priceRemindElement.setAttribute('id', 'price_remind')
          priceRemindElement.classList.add('text-xs', 'font-bold', 'text-grey-darkest', 'mb-8', 'px-8', 'text-center', 'break-words', 'whitespace-normal')
          priceRemindElement.style.maxWidth = '500px'
          priceRemindElement.textContent += this.$t('currencyRemain', { currency: this.selectedCurrency })
          calendarTargets[0].appendChild(priceRemindElement)
        }

        calendarTargets[0].appendChild(newElement)
      }
    },
    doValidate: function () {
      return this.$validate().then(success => {
        if (success) {
          return {
            start: this.start,
            end: this.end
          }
        } else {
          this.focusHandler()
          throw this.validation
        }
      })
    },
    focusHandler: function () {
      if (this.isDesktop || this.forceDesktop) {
        this.$refs.datePicker.focusHandler()
      } else {
        this.isMobileFocus = true
      }
    },
    onInput: function (value) { // 套件會自動將時間晚的放在end, 早的在start
      if (value?.start && value?.end) {
        const isSameOrAfter = this.$dayjs(value?.start).isSameOrAfter(this.$dayjs(value?.end), 'day')

        this.$set(this, 'start', value?.start)
        if (isSameOrAfter) { // 選同一天的話
          const endDate = this.$dayjs(value?.end).add(1, 'day').toDate()
          this.$set(this, 'end', endDate)
        } else {
          this.$set(this, 'end', value?.end)
        }
        this.nightCount = this.$dayjs(value.end).diff(value.start, 'day')
      }
      this.isDraging = false
      this.$refs.datePicker.blurHandler()
      this.isMobileFocus = false
    },
    onDrag: function (value) {
      value ? this.isDraging = value : this.isDraging = false
      if (value) {
        if (value?.start) {
          this.setDatePickerAttribute(value.start)
          if (value?.end) {
            this.setNightCount({ startDate: value.start, endDate: value.end })
          }
        }
      }
    },
    dateInputClick: function () {
      if (this.$route.name === 'Home') {
        window.dataLayer.push({
          event: 'index_searchbar_date'
        })
      } else {
        window.dataLayer.push({
          event: 'list_searchbar_date'
        })
      }
      this.onShow()
    },
    onShow: function () {
      this.createTextElement()
      this.setNightCount({ startDate: this.$dayjs(this.value.start).toDate(), endDate: this.$dayjs(this.value.end).toDate() })
    },
    onHide: function () {
      this.setNightCount({})
      this.isDraging = false
    },
    setDatePickerAttribute: function (startDate) {
      if (this.setQuarantineDatepickerStyle && startDate) {
        const period = this.getQuarantinePeriod(startDate)
        this['hotels/SET_QUARANTINE_DATEPICKER_STYLE']({ period, startDate })
      } else {
        this['hotels/SET_QUARANTINE_DATEPICKER_STYLE']({})
      }
    },
    setNightCount: function ({ startDate = undefined, endDate = undefined }) {
      const textTarget = document.getElementById('night_count')

      this.nightCount = this.$dayjs(endDate).diff(startDate, 'day')
      if (textTarget) {
        textTarget.textContent = this.nightCount > 0 ? this.$t('nightCount', { count: this.nightCount }) : ''
      }
    },
    resetRange () {
      this.start = null // or a date
      this.end = null // or a date
      this.datePickerKey++
    },
    checkActive (day) {
      if (this.$dayjs(day).isSame(this.value.start, 'day') || this.$dayjs(day).isSame(this.value.end, 'day')) {
        return true
      }
      return false
    },
    monthChange ({ month, year }) {
      // console.log('monthChange', month, year)
    },
    checkPriceColor (trend) {
      if (trend === 'low') {
        return '#32a923'
      } else if (trend === 'high') {
        return '#e12d2d'
      } else {
        return '#5c656b'
      }
    },
    checkDayPrice (day) {
      if (this.hotel?.hotelSource === 'hotelbeds' || this.hotel?.hotelSource === 'yokoso') {
        return '　'
      }
      const item = this.inventoryPrice?.find(e => Object.keys(e)[0] === day.id)
      return (item && Object.values(item)[0].price)
        ? `<span style="color: ${this.checkPriceColor(Object.values(item)[0].priceTrend)}">${Object.values(item)[0].price}</span>` : '　'
    },
    chcekDays (day) {
      console.log('day', day)
    },
    checkAttrs (attrs) {
      console.log('attrs', attrs)
    }
  },
  mounted () {
    const startDateQuery = this.$route.query.start
    const endDateQuery = this.$route.query.end

    if (startDateQuery && endDateQuery) {
      this.setNightCount({ startDate: this.$dayjs(startDateQuery).toDate(), endDate: this.$dayjs(endDateQuery).toDate() })
    }
  },
  // beforeMount () {
  //   Modal.event.$on('focus', this.focus)
  //   // Modal.event.$on('set', this.setTop)
  //   // Modal.event.$on('focus', this.focusTo)
  // },
  // beforeDestroy () {
  //   Modal.event.$off('focus', this.focus)
  //   // Modal.event.$on('set', this.setTop)
  //   // Modal.event.$off('focus', this.focusTo)
  // },
  watch: {
    $route: {
      handler: function ($route) {
        if ($route.query.start && $route.query.end) {
          this.resetRange()
          const startDate = this.$dayjs($route.query.start).toDate()
          const endDate = this.$dayjs($route.query.end).toDate()

          this.$set(this, 'start', startDate)
          this.$set(this, 'end', endDate)
          this.setDatePickerAttribute(startDate)
          this.setNightCount({ startDate, endDate })
        } else {
          this.resetRange()
          this.$set(this, 'start', null)
          this.$set(this, 'end', null)
          this.setDatePickerAttribute()
          this.setNightCount({})
        }
      },
      immediate: true
    },
    selectedCurrency: {
      handler: function (val) {
        const remindTarget = document.getElementById('price_remind')
        remindTarget.textContent = this.$t('currencyRemain', { currency: this.selectedCurrency })
      }
    }
  }
}
</script>

<style lang="sass">
.vc-pane-container
  .vc-highlights ~ .is-disabled
    background: #F8FAFC !important
    color: #D1D7DD !important
.owj-calendar.inHotelDetail
  .vc-weekday
    @apply text-black
  .vc-day
    @apply flex flex-col
    justify-content: center
    align-items: center
    transform-origin: 50% 50%
    .vc-day-layer
      top: -5px
    .vc-highlights.vc-day-layer + .vc-day-content
      // @apply text-white
    .vc-highlights.vc-day-layer
      .vc-day-box-center-center
        .vc-highlight:not(.vc-highlight-base-middle)
          background: #63b3ed !important
</style>
